export enum DownloadTypes {
    web = 'Web',
    print = 'Print'
}

export const DOWNLOAD_SIZE_LIMIT = 5000;